// Copyright 2025 Imprivata, Inc. All rights reserved.

import type { CodingContext } from '@imprivata-cloud/dataprivacy';
import { useMutation } from '@tanstack/react-query';
import { assignTempCode } from '../../../../api/portalServices';
import type { TempCodeAssignRequest, TempCodeAssignResponse } from '../../../../api/types';

export type AssignTempCodeParams = { request: TempCodeAssignRequest; codingContext: CodingContext };

export const useAssignTempCode = () => {
  return useMutation<TempCodeAssignResponse, Error, AssignTempCodeParams>({
    mutationFn: (data: AssignTempCodeParams) => assignTempCode(data.request, data.codingContext),
  });
};
